<template>
    <div :class="`cart-menu`">
        <mini-cart-button
            :item-count="cartItems.length"
        ></mini-cart-button>

        <div class="submenu">
            <div :class="`${cartItems.length > 0 ? 'd-none' : 'd-block'}`">
                <h6 class="text-center my-4 font-weight-bold">{{ __('minicart.empty') }}</h6>
            </div>

            <div :class="`${cartItems.length > 0 ? 'd-block' : 'd-none'}`">
                <div class="products">
                    <div class="product d-flex align-items-start" :key="index" v-for="(item, index) in cartItems">
                        <img :src="item.images.medium_image_url" alt="" class="mr-2" width="60" height="60" />
                        <div class="product-data">
                            <p class="mb-0"><a :href="`${$root.baseUrl}/${item.url_key}`" target="_self" title="">{{ item.name }}</a></p>
                            <p class="mb-0 d-flex align-items-center justify-content-between">
                                <span>{{ __('minicart.amount_text') }}: <strong>{{item.quantity}} {{ __('index.unit_label') }}</strong></span>
                                <span>
                                    <a href="#" @click="removeProduct(item.id)">
                                        <img src="/images/delete.svg" width="10" height="10" />
                                    </a>
                                </span>
                            </p>
                            <p class="mb-0">{{ __('checkout.price') }}: <strong>{{ item.base_total }}</strong></p>
                            <p class="mb-0 d-flex align-items-center justify-content-between" v-for="(service, index) in item.services">
                                <span><strong>{{ service.name }}</strong></span>
                                <span>{{ service.base_total }}</span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="sum">
                    <p class="mb-0"><small class="w-100 mb-0 d-flex align-items-center justify-content-between"><span>{{ __('minicart.without_vat') }}</span><span>{{ cartInformation.base_sub_total }}</span></small></p>
                    <p class="w-100 mb-0 d-flex align-items-center justify-content-between"><span>{{ __('minicart.with_vat') }}:</span><span>{{ cartInformation.base_grand_total }}</span></p>
                </div>

                <div class="btns d-flex align-items-center justify-content-between flex-wrap">
                    <div class="w-100 d-flex align-items-center justify-content-between">
                        <a :href="viewCart" target="_self" title="" class="btn-yellow-bordered rounded black">{{ __('minicart.cart_button') }}</a>
                        <a :href="checkoutUrl" target="_self" title="" class="btn-yellow dark-border rounded black">{{ __('minicart.checkout_button') }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'cartText',
            'viewCart',
            'checkoutUrl',
            'checkoutText',
            'subtotalText',
            'checkMinimumOrderUrl'
        ],

        data: function () {
            return {
                cartItems: [],
                cartInformation: [],
            }
        },

        mounted: function () {
            this.getMiniCartDetails();
        },

        watch: {
            '$root.miniCartKey': function () {
                this.getMiniCartDetails();
            }
        },

        methods: {
            getMiniCartDetails: function () {
                this.$http.get(`${this.$root.baseUrl}/mini-cart`)
                    .then(response => {
                        if (response.data.status) {
                            this.cartItems = response.data.mini_cart.cart_items;
                            this.cartInformation = response.data.mini_cart.cart_details;
                        }
                    })
                    .catch(exception => {
                        console.log(this.__('error.something_went_wrong'));
                    });
            },

            removeProduct: function (productId) {
                this.$http.delete(`${this.$root.baseUrl}/cart/remove/${productId}`)
                    .then(response => {
                        this.cartItems = this.cartItems.filter(item => item.id != productId);
                        this.$root.miniCartKey++;

                        location.reload();
                        window.showAlert(`alert-${response.data.status}`, response.data.label, response.data.message);
                    })
                    .catch(exception => {
                        location.reload();
                        console.log(this.__('error.something_went_wrong'));
                    });
            },

            checkMinimumOrder: function (e) {
                e.preventDefault();

                this.$http.post(this.checkMinimumOrderUrl)
                    .then(({ data }) => {
                        if (! data.status) {
                            window.showAlert(`alert-warning`, 'Warning', data.message);
                        } else {
                            window.location.href = this.checkoutUrl;
                        }
                    });
            }
        }
    }
</script>
